import { Component, ViewChild, ViewContainerRef, AfterViewInit, Input } from '@angular/core';
import { FactoryService } from '@dotgov/core';

@Component({
  selector: 'interface-dynamic-renderer',
  template: `<ng-container #container></ng-container>`,
  styles: [``],
})
export class DynamicRendererComponent implements AfterViewInit {
  @ViewChild('container', { read: ViewContainerRef }) container;
  @Input('component') componentName: string;
  @Input('item') item: any;

  constructor(private _factory: FactoryService) { }

  ngAfterViewInit() {
    this._factory.componentByName(this.componentName, this.container, { preview: false, item: this.item });
  }
}
